export default [
  {path: '/login', name: 'Login', component: () => import('@/views/common/Login.vue')},
  {path: '/test/xys/test1', name: 'TestXysTest1', component: () => import('@/views/test/xys/Test1.vue')},
  {path: '/test/xys/test2', name: 'TestXysTest2', component: () => import('@/views/test/xys/Test2.vue')},
  {path: '/test/xys/test3', name: 'TestXysTest3', component: () => import('@/views/test/xys/Test3.vue')},
  {path: '/edit/v2', name: 'EditV2', component: () => import('@/views/edit/EditV2.vue')},
  {path: '/show/v2', name: 'ShowV2', component: () => import('@/views/show/ShowV2.vue')},
]